import { Progress, ProgressProps } from '@mantine/core';
import { vars } from 'src/core/themes';

export const PosProgressBar = (props: ProgressProps) => {
  return <Progress color={vars.color.backgroundBrand} {...props} />;
};
